import { IdentityUserTypes } from 'dataSource/auth/types'

export function setRudderstackAnonymousId(anonymousId: string): void {
  if (globalThis.rudderanalytics) {
    globalThis.rudderanalytics.setAnonymousId(anonymousId)
    logIdentity() // This will stay anonymous but will then add the userType to the previously logged in userType
  }
}

export function saveRoleToLocalStorage(userType: IdentityUserTypes): void {
  localStorage.setItem('userType', userType)
}

// If the user is logged in, we will log their identity to rudderstack and save their userType to localStorage
// If the user is not logged in, we will log their anonymousId to rudderstack and use their saved userType from the previous login

const internalRoles = [IdentityUserTypes.SUPPORT, IdentityUserTypes.CLINICIAN]

export const logIdentity = (userId = '', userType = null): void => {
  let role = userType

  if (userType) {
    saveRoleToLocalStorage(userType)
  } else {
    role = localStorage.getItem('userType')
  }

  const internal = internalRoles.includes(role)
  const userProperties = role ? { userType: role, internal } : { internal }

  // Check that heap is loaded before attempting to run this
  // FYI: globalThis is the way you are supposed to now do things that we used to do with window.*
  if (globalThis.heap) {
    // Heap specifically requests that you don't use non-unique values for identify
    // so doing a little extra check here to make sure this wasn't called blank.
    if (userId !== '') {
      globalThis.heap.identify(userId)
      globalThis.heap.addUserProperties(userProperties)
    }
  }

  // Register with Rudderstack, and check it's loaded first too
  if (globalThis.rudderanalytics) {
    globalThis.rudderanalytics.identify(userId, userProperties)
  }
}
